import { IconType } from 'react-icons';
import {
  FiUsers,
  FiUserPlus,
  FiTarget,
  FiCheckSquare,
  FiSettings,
  FiDatabase,
  FiList,
  FiGitBranch,
  FiSearch,
  FiTool,
  FiLayout,
  FiMessageCircle,
  FiSave,
} from 'react-icons/fi';

export interface SiteRoute {
  path: string;
  label: string;
  icon: IconType;
  children?: SiteRoute[];
  showInMenu?: boolean;
}

export interface NavigationGroup {
  id: string;
  label: string;
  icon: IconType;
  routes: SiteRoute[];
}

// ─── Top-level routes (function-based dashboards) ───────────────────
export const topLevelRoutes: SiteRoute[] = [
  {
    path: 'dashboard',
    label: 'Dashboard',
    icon: FiLayout,
    showInMenu: true,
  },
  {
    path: 'work',
    label: 'Your Work',
    icon: FiCheckSquare,
    showInMenu: true,
  },
  {
    path: 'teams',
    label: 'Your Teams',
    icon: FiUsers,
    showInMenu: true,
  },
  {
    path: 'interests',
    label: 'Your Interests',
    icon: FiTarget,
    showInMenu: true,
  },
];

// ─── Footer route (rendered separately, just above the user profile) ─
export const assistantRoute: SiteRoute = {
  path: 'assistant',
  label: 'Assistant',
  icon: FiMessageCircle,
  showInMenu: true,
};

// ─── Navigation groups ──────────────────────────────────────────────
export const navigationGroups: NavigationGroup[] = [
  {
    id: 'data',
    label: 'Data',
    icon: FiSearch,
    routes: [
      {
        path: 'data/explore',
        label: 'Explore',
        icon: FiSearch,
        showInMenu: true,
      },
      {
        path: 'data/workflows',
        label: 'Workflows',
        icon: FiGitBranch,
        showInMenu: true,
      },
    ],
  },
  {
    id: 'workspace',
    label: 'Workspace',
    icon: FiSettings,
    routes: [
      {
        path: 'workspace/settings',
        label: 'Settings',
        icon: FiSettings,
        showInMenu: true,
      },
      {
        path: 'workspace/data-sources',
        label: 'Data Sources',
        icon: FiDatabase,
        showInMenu: true,
      },
      {
        path: 'workspace/invitations',
        label: 'Invitations',
        icon: FiUserPlus,
        showInMenu: true,
      },
      {
        path: 'workspace/pending-changes',
        label: 'Pending Changes',
        icon: FiSave,
        showInMenu: true,
      },
      {
        path: 'workspace/history',
        label: 'History',
        icon: FiList,
        showInMenu: true,
      },
      {
        path: 'workspace/tools',
        label: 'Tools',
        icon: FiTool,
        showInMenu: true,
      },
    ],
  },
];

// ─── All routes (flat list for lookups) ─────────────────────────────
export const siteRoutes: SiteRoute[] = [
  ...topLevelRoutes,
  assistantRoute,
  ...navigationGroups.flatMap(g => g.routes),
];

// Utility function to get a route by path
export const getRouteByPath = (path: string): SiteRoute | undefined => {
  return siteRoutes.find(route => route.path === path);
};
